import { usePostTypeField } from 'screens/Schedule/EditChannelsModal/usePostTypeField'
import { useField } from 'formik'
import Styles from 'screens/Schedule/EditChannelsModal/Accounts.module.scss'
import { Account } from 'screens/Schedule/EditChannelsModal/Account'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { CrosspostAccountsProps } from 'screens/Schedule/EditChannelsModal/Crosspost/Types'
import { useTacticWithCount } from 'screens/Schedule/EditChannelsModal/useTacticWithCount'

export const CrosspostAccounts = ({ crosspostField, contentType, integrations, tactic }: CrosspostAccountsProps) => {
  const [field] = usePostTypeField({ name: crosspostField, postType: 'post', contentType })
  const [accountIdsField, , { setValue: setAccountIds }] = useField<Array<number> | undefined>(
    `${field.name}.account_ids`,
  )
  const { tactics, addTactic, removeTactic } = useTacticWithCount(field.name)

  const tacticAccountIds = (accountIdsField.value || []).filter((id: any) =>
    integrations.map((integration) => integration.id).includes(id),
  )

  return (
    <div key={tactic}>
      {integrations.map((integration) => (
        <div
          className={Styles.account}
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          key={integration.id}
        >
          <Account integration={integration} />
          <ToggleButton
            checked={(accountIdsField.value || []).includes(integration.id)}
            name={`${accountIdsField.name}.${integration.id}`}
            handleChange={(e) => {
              const checked = e.target.checked
              const isOnlyAccountForTactic = tacticAccountIds.length === 1 && tacticAccountIds[0] === integration.id

              if (checked) {
                setAccountIds([...(accountIdsField.value || []), integration.id])
                if (!tactics.includes(tactic)) addTactic(tactic)
              } else {
                setAccountIds((accountIdsField.value || []).filter((id) => id !== integration.id))
                if (isOnlyAccountForTactic) removeTactic(tactic)
              }
            }}
            size="sm-md"
          />
        </div>
      ))}
    </div>
  )
}
